module.exports = __webpack_public_path__ + "static/img/logo.c207f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo.png
// module id = vJvE
// module chunks = 25